import { enableSheetDrag } from '@theme/sheet-drag';

const mobile = matchMedia('(max-width: 749px)');

/**
 * `<plw-cart-handle>` — the cart drawer's mobile bottom-sheet drag affordance.
 *
 * The cart drawer is Horizon's `<cart-drawer-component>` (which, like the PLW
 * search overlay, extends `DialogComponent`), so we wire its top handle through
 * the same shared {@link enableSheetDrag} helper. The result: the cart sheet
 * drags down to dismiss exactly like every other PLW slide-out. Pure progressive
 * enhancement — the handle is just a hairline if this never upgrades.
 */
class PlwCartHandle extends HTMLElement {
  /** @type {{ reset: () => void, destroy: () => void } | null} */
  #drag = null;
  /** @type {(HTMLElement & { close?: () => void }) | null} */
  #component = null;

  connectedCallback() {
    const dialog = /** @type {HTMLDialogElement | null} */ (this.closest('dialog'));
    this.#component = this.closest('cart-drawer-component');
    if (!dialog || !this.#component) return;

    this.#drag = enableSheetDrag({
      dialog,
      handle: this,
      surface: dialog,
      isMobile: () => mobile.matches,
      onDismiss: () => this.#component?.close?.(),
      dragVar: '--plw-cart-drag',
    });
    this.#component.addEventListener('dialog:close', this.#drag.reset);
  }

  disconnectedCallback() {
    if (!this.#drag) return;
    this.#component?.removeEventListener('dialog:close', this.#drag.reset);
    this.#drag.destroy();
    this.#drag = null;
  }
}

if (!customElements.get('plw-cart-handle')) {
  customElements.define('plw-cart-handle', PlwCartHandle);
}
